import { Box, Typography } from '@mui/material';

export default function Footer() {
  return (
    <Box sx={{ p: 3, bgcolor: 'primary.main', color: 'white', mt: 'auto' }}>
      <Typography variant="body2" align="center">
        © {new Date().getFullYear()} ReVisionari - All rights reserved
      </Typography>
    </Box>
  );
}
